import fetcher from 'features/shared/utils/fetcher'
import { PatientsModel } from 'features/shared/types/userType'

export async function getListPatients(page: number) {
  return await fetcher.get<{data: PatientsModel}>('/patients/'+'?page='+page);
}